class SasaProductGallery {
  constructor() {
    this.galleries = document.querySelectorAll('.product--sasa media-gallery');
    if (!this.galleries.length) return;

    this.galleries.forEach((gallery) => this.initGallery(gallery));
  }

  initGallery(gallery) {
    const viewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (!viewer) return;

    const prevButton = viewer.querySelector('.slider-button--prev');
    const nextButton = viewer.querySelector('.slider-button--next');
    const sliderButtons = viewer.querySelector('.slider-buttons');
    const thumbnailButtons = Array.from(gallery.querySelectorAll('.thumbnail-list__item button'));
    const slides = Array.from(viewer.querySelectorAll('.product__media-item[data-media-id]'));

    if (!prevButton || !nextButton || !sliderButtons) return;

    const getCount = () => (thumbnailButtons.length > 0 ? thumbnailButtons.length : slides.length);

    const getCurrentIndex = () => {
      if (thumbnailButtons.length > 0) {
        return thumbnailButtons.findIndex((button) => button.getAttribute('aria-current') === 'true');
      }

      return slides.findIndex((slide) => slide.classList.contains('is-active'));
    };

    const updateArrows = () => {
      const count = getCount();

      if (count <= 1) {
        sliderButtons.classList.add('sasa-gallery-nav--hidden');
        return;
      }

      sliderButtons.classList.remove('sasa-gallery-nav--hidden');

      const index = getCurrentIndex();
      const atStart = index <= 0;
      const atEnd = index >= count - 1;

      prevButton.classList.toggle('sasa-gallery-arrow--hidden', atStart);
      nextButton.classList.toggle('sasa-gallery-arrow--hidden', atEnd);
      prevButton.disabled = atStart;
      nextButton.disabled = atEnd;
    };

    const goToIndex = (index) => {
      const count = getCount();
      if (index < 0 || index >= count) return;

      if (thumbnailButtons[index]) {
        thumbnailButtons[index].click();
        return;
      }

      const mediaId = slides[index]?.dataset.mediaId;
      if (mediaId && typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(mediaId, false);
      }
    };

    const goTo = (direction) => {
      const index = getCurrentIndex();
      if (index === -1) return;
      goToIndex(direction === 'next' ? index + 1 : index - 1);
    };

    prevButton.addEventListener(
      'click',
      (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        goTo('prev');
        window.setTimeout(updateArrows, 50);
      },
      true
    );

    nextButton.addEventListener(
      'click',
      (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        goTo('next');
        window.setTimeout(updateArrows, 50);
      },
      true
    );

    thumbnailButtons.forEach((button) => {
      button.addEventListener('click', () => window.setTimeout(updateArrows, 50));
    });

    viewer.addEventListener('slideChanged', () => window.setTimeout(updateArrows, 50));

    const thumbnailList = gallery.querySelector('.thumbnail-list');
    if (thumbnailList) {
      const observer = new MutationObserver(() => updateArrows());
      thumbnailButtons.forEach((button) => {
        observer.observe(button, { attributes: true, attributeFilter: ['aria-current'] });
      });
    }

    const slideObserver = new MutationObserver(() => updateArrows());
    slides.forEach((slide) => {
      slideObserver.observe(slide, { attributes: true, attributeFilter: ['class'] });
    });

    updateArrows();
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new SasaProductGallery();
  });
} else {
  new SasaProductGallery();
}
